import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'date-tooltip',
    templateUrl: './date-tooltip.component.html',
    styleUrls: ['./date-tooltip.component.scss'],
})
export class DateTooltipComponent implements OnInit {

    @Input('date') Date: string;
    @Input('tooltip') Tooltip: boolean = true;
    constructor() { }

    ngOnInit() { }

}
